export default "__VITE_ASSET__98c633ac__"